import React from "react";
import categoryImage1 from "../../images/shirt.webp"; // Import your category images here
import categoryImage2 from "../../images/pant.webp"; // Import your category images here
import categoryImage3 from "../../images/tshirt.webp"; // Import your category images here
import categoryImage4 from "../../images/cargo.jpg"; // Import your category images here
import categoryImage5 from "../../images/sale.jpg";
import categoryImage6 from "../../images/hoodie.webp";
import { Link } from "react-router-dom";

const categories = [
  { id: 1, name: "SHIRTS", link: "SHIRTS", image: categoryImage1 },
  { id: 2, name: "PANTS", link: "PANTS", image: categoryImage2 },
  { id: 3, name: "T-SHIRT", link: "T-SHIRT", image: categoryImage3 },
  { id: 4, name: "CARGO", link: "CARGO", image: categoryImage4 },
  { id: 5, name: "ON SALE", link: "allproduct", image: categoryImage5 },
  { id: 6, name: "HOODIES", link: "HOODIE", image: categoryImage6 },
];

const CategoryList = () => {
  return (
    <div className="text-center mb-10 m-5">
      <p className="text-xl md:text-3xl font-medium font-sans text-gray-800">
        Explore Categories
      </p>
      <div className="w-9 h-0.5 bg-red-600 mx-auto mt-4 md:mb-12 mb-6"></div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
        {categories.map((category) => (
          <div
            key={category.id}
            className="bg-gray-300 rounded-lg overflow-hidden transform transition duration-100 hover:scale-110 relative"
          >
            <Link to={`/allproduct/${category.link}`} className="block">
              <img
                src={category.image}
                alt={category.name}
                className="w-full h-40 object-cover"
              />
              <div className="p-2">
                <h3 className="text-md font-semibold text-gray-800">
                  {category.name}
                </h3>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryList;
